export enum Os {
  ANDROID = 'AOS',
  IOS = 'iOS',
  UNKNOWN = 'Unknown',
}

export function getOsType(): Os {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Android') !== -1) return Os.ANDROID;
  if (/iPhone|iPad|iPod/.test(userAgent)) return Os.IOS;

  // unknown 처리할 페이지가 없으니 사용자가 더 많은 iOS로 설정
  return Os.UNKNOWN;
}

export function isMobileBrowser(): boolean {
  const osType = getOsType();
  return [Os.IOS, Os.ANDROID].includes(osType);
}

export const OS_TYPE =
  import.meta.env.VITE_NODE_ENV === 'development'
    ? getDeviceTypeDev()
    : getDeviceType();

function getDeviceTypeDev() {
  return 'iOS';
}

function getDeviceType() {
  const osType = getOsType();
  return osType === Os.ANDROID ? Os.ANDROID : Os.IOS;
}
